import { render, staticRenderFns } from "./PageIndicator.vue?vue&type=template&id=837608f8&scoped=true&"
import script from "./PageIndicator.vue?vue&type=script&lang=js&"
export * from "./PageIndicator.vue?vue&type=script&lang=js&"
import style0 from "./PageIndicator.vue?vue&type=style&index=0&id=837608f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837608f8",
  null
  
)

export default component.exports